{
  "openapi": "3.1.0",
  "info": {
    "title": "Cardano API",
    "description": "RESTful API for Cardano",
    "contact": {
      "name": "Real1ty"
    },
    "license": {
      "name": "LicenseRef-Proprietary",
      "identifier": "LicenseRef-Proprietary"
    },
    "version": "1.0.0"
  },
  "paths": {
    "/api/addresses/{address}": {
      "get": {
        "tags": [
          "Addresses"
        ],
        "operationId": "get_address_utxos_by_address",
        "parameters": [
          {
            "name": "address",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Unspent outputs at the address, from the pool index",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AddressUtxosResponse"
                }
              }
            }
          }
        }
      }
    },
    "/api/arbitrages": {
      "get": {
        "tags": [
          "Arbitrages"
        ],
        "operationId": "get_arbitrages",
        "parameters": [
          {
            "name": "min_profit_ada",
            "in": "query",
            "description": "Only opportunities whose profit is at least this many ADA. A viewing filter: the bot\nstill detects and records everything below it.",
            "required": false,
            "schema": {
              "type": "number",
              "format": "double"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Detected opportunities, most profitable first",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ArbitragesResponse"
                }
              }
            }
          },
          "400": {
            "description": "`min_profit_ada` is negative or not a number"
          }
        }
      }
    },
    "/api/arbitrages/get-execute-trade": {
      "get": {
        "tags": [
          "Arbitrages"
        ],
        "operationId": "get_execute_trade",
        "responses": {
          "200": {
            "description": "Whether the bot submits trades",
            "content": {
              "application/json": {
                "schema": {
                  "type": "boolean"
                }
              }
            }
          }
        }
      }
    },
    "/api/arbitrages/history": {
      "get": {
        "tags": [
          "Arbitrages"
        ],
        "operationId": "get_arbitrages_history",
        "responses": {
          "200": {
            "description": "Executed arbitrage transactions",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/TransactionHistoryResponse"
                }
              }
            }
          }
        }
      }
    },
    "/api/dexes": {
      "get": {
        "tags": [
          "Pools"
        ],
        "operationId": "get_available_dexes",
        "responses": {
          "200": {
            "description": "The dexes the bot follows",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AvailableDexesResponse"
                }
              }
            }
          }
        }
      }
    },
    "/api/opportunities": {
      "get": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "get_opportunities",
        "parameters": [
          {
            "name": "actionable_only",
            "in": "query",
            "description": "Only windows that clear the thresholds (default true).",
            "required": false,
            "schema": {
              "type": "boolean"
            }
          },
          {
            "name": "limit",
            "in": "query",
            "description": "Page size, 1–200 (default 50).",
            "required": false,
            "schema": {
              "type": "integer",
              "minimum": 0
            }
          },
          {
            "name": "page",
            "in": "query",
            "description": "The 1-based page, newest first (default 1).",
            "required": false,
            "schema": {
              "type": "integer",
              "minimum": 0
            }
          },
          {
            "name": "pair",
            "in": "query",
            "description": "Only this pair (`lovelace/<unit>`).",
            "required": false,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "One page of opportunity windows",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OpportunityPage"
                }
              }
            }
          },
          "400": {
            "description": "`limit` outside 1–200, or `page` 0"
          }
        }
      }
    },
    "/api/opportunities/notifications": {
      "get": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "get_notifications",
        "responses": {
          "200": {
            "description": "Whether alerts are on, where they go, and how the last went",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/NotificationState"
                }
              }
            }
          }
        }
      }
    },
    "/api/opportunities/notifications/thresholds": {
      "put": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "set_notify_thresholds",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/Thresholds"
              }
            }
          },
          "required": true
        },
        "responses": {
          "200": {
            "description": "The notification state after the override",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/NotificationState"
                }
              }
            }
          }
        }
      },
      "delete": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "reset_notify_thresholds",
        "responses": {
          "200": {
            "description": "The notification state after the reset",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/NotificationState"
                }
              }
            }
          }
        }
      }
    },
    "/api/opportunities/notify-test": {
      "post": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "send_test_notification",
        "responses": {
          "200": {
            "description": "The test notification was delivered",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/NotificationState"
                }
              }
            }
          },
          "409": {
            "description": "Notifications are off: ARB_NOTIFY_ENABLED=false"
          },
          "502": {
            "description": "The channel refused or did not answer"
          }
        }
      }
    },
    "/api/opportunities/prune": {
      "post": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "prune_opportunities",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/PruneRequest"
              }
            }
          },
          "required": true
        },
        "responses": {
          "200": {
            "description": "How many windows were pruned",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PruneResponse"
                }
              }
            }
          }
        }
      }
    },
    "/api/opportunities/stats": {
      "get": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "get_opportunity_stats",
        "parameters": [
          {
            "name": "days",
            "in": "query",
            "description": "UTC days back from the newest chain time, 1–90 (default 14).",
            "required": false,
            "schema": {
              "type": "integer",
              "format": "int32",
              "minimum": 0
            }
          },
          {
            "name": "pair",
            "in": "query",
            "description": "Only this pair (`lovelace/<unit>`), as the top pairs name it.",
            "required": false,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Opportunity statistics for the period",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OpportunityStats"
                }
              }
            }
          },
          "400": {
            "description": "`days` outside 1–90"
          }
        }
      }
    },
    "/api/opportunities/thresholds": {
      "get": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "get_opportunity_thresholds",
        "responses": {
          "200": {
            "description": "The effective thresholds",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ThresholdsState"
                }
              }
            }
          }
        }
      },
      "put": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "set_opportunity_thresholds",
        "requestBody": {
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/Thresholds"
              }
            }
          },
          "required": true
        },
        "responses": {
          "200": {
            "description": "The thresholds after the override",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ThresholdsState"
                }
              }
            }
          }
        }
      },
      "delete": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "reset_opportunity_thresholds",
        "responses": {
          "200": {
            "description": "The thresholds after the reset",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ThresholdsState"
                }
              }
            }
          }
        }
      }
    },
    "/api/opportunities/{id}": {
      "get": {
        "tags": [
          "Opportunities"
        ],
        "operationId": "get_opportunity",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int64",
              "minimum": 0
            }
          }
        ],
        "responses": {
          "200": {
            "description": "The window with its event trail",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/OpportunityDetail"
                }
              }
            }
          },
          "404": {
            "description": "No window with this id"
          }
        }
      }
    },
    "/api/pairs": {
      "get": {
        "tags": [
          "Pairs"
        ],
        "operationId": "get_pools_by_pair",
        "parameters": [
          {
            "name": "asset_a",
            "in": "query",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "asset_b",
            "in": "query",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Every pool trading the pair",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PairsResponse"
                }
              }
            }
          },
          "404": {
            "description": "No pool trades this pair"
          }
        }
      }
    },
    "/api/pools/{dex}": {
      "get": {
        "tags": [
          "Pools"
        ],
        "operationId": "get_pools_by_dex",
        "parameters": [
          {
            "name": "dex",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "page",
            "in": "query",
            "required": false,
            "schema": {
              "type": "integer",
              "minimum": 0
            }
          }
        ],
        "responses": {
          "200": {
            "description": "One page of the pools on this dex",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PoolsResponse"
                }
              }
            }
          }
        }
      }
    },
    "/api/regulus/address/{address}": {
      "get": {
        "tags": [
          "Regulus"
        ],
        "operationId": "get_regulus_address_utxos",
        "parameters": [
          {
            "name": "address",
            "in": "path",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Unspent outputs at the address",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/AddressUtxosResponse"
                }
              }
            }
          }
        }
      }
    },
    "/api/regulus/point": {
      "get": {
        "tags": [
          "Regulus"
        ],
        "operationId": "get_regulus_point",
        "responses": {
          "200": {
            "description": "The chain point of the pool index",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/DisplayPoint"
                }
              }
            }
          }
        }
      }
    },
    "/api/regulus/utxo": {
      "get": {
        "tags": [
          "Regulus"
        ],
        "operationId": "get_regulus_utxo",
        "parameters": [
          {
            "name": "transaction_id",
            "in": "query",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "index",
            "in": "query",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int64",
              "minimum": 0
            }
          }
        ],
        "responses": {
          "200": {
            "description": "The UTXO",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/DisplayUtxo"
                }
              }
            }
          },
          "404": {
            "description": "No such UTXO"
          }
        }
      }
    },
    "/api/utxos": {
      "get": {
        "tags": [
          "UTXOs"
        ],
        "operationId": "lookup_utxo",
        "parameters": [
          {
            "name": "transaction_id",
            "in": "query",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "index",
            "in": "query",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int64",
              "minimum": 0
            }
          }
        ],
        "responses": {
          "200": {
            "description": "The UTXO",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UtxoResponse"
                }
              }
            }
          },
          "404": {
            "description": "No such UTXO"
          }
        }
      }
    },
    "/api/wallet/point": {
      "get": {
        "tags": [
          "Wallet"
        ],
        "operationId": "get_wallet_point",
        "responses": {
          "200": {
            "description": "The chain point of the wallet index",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/DisplayPoint"
                }
              }
            }
          }
        }
      }
    },
    "/api/wallet/utxo": {
      "get": {
        "tags": [
          "Wallet"
        ],
        "operationId": "get_wallet_utxo",
        "parameters": [
          {
            "name": "transaction_id",
            "in": "query",
            "required": true,
            "schema": {
              "type": "string"
            }
          },
          {
            "name": "index",
            "in": "query",
            "required": true,
            "schema": {
              "type": "integer",
              "format": "int64",
              "minimum": 0
            }
          }
        ],
        "responses": {
          "200": {
            "description": "The wallet UTXO",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/DisplayUtxo"
                }
              }
            }
          },
          "404": {
            "description": "No such UTXO"
          }
        }
      }
    }
  },
  "components": {
    "schemas": {
      "AddressUtxosResponse": {
        "type": "object",
        "required": [
          "utxos",
          "found",
          "address"
        ],
        "properties": {
          "address": {
            "type": "string"
          },
          "found": {
            "type": "boolean"
          },
          "utxos": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/DisplayUtxo"
            }
          }
        }
      },
      "AppEvent": {
        "type": "string",
        "description": "A change announced on `GET /api/events` (`text/event-stream`): one `data:` frame per event,\nholding its JSON-encoded name. Not an operation in this document, since it never completes.",
        "enum": [
          "arbitrages_changed",
          "opportunities_changed",
          "arbitrage_history_changed",
          "pools_changed",
          "chain_advanced",
          "resync"
        ]
      },
      "ArbitrageDisplayItem": {
        "type": "object",
        "required": [
          "buy_pool",
          "sell_pool",
          "buy_amount",
          "buy_receive_amount",
          "sell_receive_amount",
          "profit_formatted",
          "profit_lovelace",
          "buy_token_name",
          "buy_token_id",
          "sell_token_name",
          "buy_pool_tvl",
          "sell_pool_tvl",
          "timestamp",
          "buy_cost_ada",
          "buy_pool_tx_id",
          "buy_pool_output_index",
          "sell_pool_tx_id",
          "sell_pool_output_index"
        ],
        "properties": {
          "buy_amount": {
            "type": "string"
          },
          "buy_cost_ada": {
            "type": "string"
          },
          "buy_pool": {
            "type": "string"
          },
          "buy_pool_output_index": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "buy_pool_tvl": {
            "type": "string"
          },
          "buy_pool_tx_id": {
            "type": "string"
          },
          "buy_receive_amount": {
            "type": "string"
          },
          "buy_token_id": {
            "type": "string",
            "description": "The bought token's unit id, so the UI can link it to an explorer."
          },
          "buy_token_name": {
            "type": "string"
          },
          "profit_formatted": {
            "type": "string"
          },
          "profit_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "sell_pool": {
            "type": "string"
          },
          "sell_pool_output_index": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "sell_pool_tvl": {
            "type": "string"
          },
          "sell_pool_tx_id": {
            "type": "string"
          },
          "sell_receive_amount": {
            "type": "string"
          },
          "sell_token_name": {
            "type": "string"
          },
          "timestamp": {
            "type": "string"
          }
        }
      },
      "ArbitrageHistoryItem": {
        "type": "object",
        "required": [
          "transaction",
          "arbitrage_text"
        ],
        "properties": {
          "arbitrage_text": {
            "type": "string"
          },
          "transaction": {
            "$ref": "#/components/schemas/Transaction"
          }
        }
      },
      "ArbitragesResponse": {
        "type": "object",
        "required": [
          "arbitrages"
        ],
        "properties": {
          "arbitrages": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ArbitrageDisplayItem"
            }
          }
        }
      },
      "AssetRef": {
        "type": "object",
        "description": "An asset as the UI names it: the ticker it shows and the unit id (`lovelace` for ADA) it links\nto on an explorer. [[spec-reusable-asset-hover-card-with-cardanoscan-links]]",
        "required": [
          "id",
          "name"
        ],
        "properties": {
          "id": {
            "type": "string"
          },
          "name": {
            "type": "string"
          }
        }
      },
      "AvailableDexesResponse": {
        "type": "object",
        "required": [
          "available_dexes"
        ],
        "properties": {
          "available_dexes": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        }
      },
      "Channel": {
        "type": "object",
        "description": "Where alerts go, as the UI shows it. Never carries a secret.",
        "required": [
          "kind",
          "target"
        ],
        "properties": {
          "kind": {
            "type": "string"
          },
          "target": {
            "type": "string"
          }
        }
      },
      "DayStats": {
        "allOf": [
          {
            "$ref": "#/components/schemas/StatsBucket"
          },
          {
            "type": "object",
            "required": [
              "date"
            ],
            "properties": {
              "date": {
                "type": "string",
                "description": "UTC calendar day (`YYYY-MM-DD`) the windows opened on."
              }
            }
          }
        ]
      },
      "DisplayAsset": {
        "type": "object",
        "required": [
          "id",
          "quantity"
        ],
        "properties": {
          "id": {
            "type": "string"
          },
          "quantity": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          }
        }
      },
      "DisplayPoint": {
        "type": "object",
        "required": [
          "slot",
          "id"
        ],
        "properties": {
          "id": {
            "type": "string"
          },
          "slot": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          }
        }
      },
      "DisplayUtxo": {
        "type": "object",
        "required": [
          "address",
          "assets",
          "datum",
          "tx_id",
          "index",
          "block_id",
          "block_slot"
        ],
        "properties": {
          "address": {
            "type": "string"
          },
          "assets": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/DisplayAsset"
            }
          },
          "block_id": {
            "type": "string"
          },
          "block_slot": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "datum": {},
          "index": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "tx_id": {
            "type": "string"
          }
        }
      },
      "EventKind": {
        "type": "string",
        "enum": [
          "opened",
          "updated",
          "closed",
          "interrupted",
          "notified",
          "notify_failed"
        ]
      },
      "Input": {
        "type": "object",
        "required": [
          "transaction",
          "index"
        ],
        "properties": {
          "index": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "transaction": {
            "$ref": "#/components/schemas/InputTransaction"
          }
        }
      },
      "InputTransaction": {
        "type": "object",
        "required": [
          "id"
        ],
        "properties": {
          "id": {
            "type": "string"
          }
        }
      },
      "NotificationState": {
        "type": "object",
        "required": [
          "enabled",
          "thresholds",
          "max_lag_secs",
          "sent",
          "failed"
        ],
        "properties": {
          "channel": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/Channel"
              },
              {
                "type": "null"
              }
            ]
          },
          "enabled": {
            "type": "boolean",
            "description": "False when no channel is configured: nothing is ever sent."
          },
          "failed": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "last_error": {
            "type": [
              "string",
              "null"
            ]
          },
          "last_error_at": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int64",
            "minimum": 0
          },
          "last_sent_at": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int64",
            "minimum": 0
          },
          "max_lag_secs": {
            "type": "integer",
            "format": "int64",
            "description": "Windows that open further behind wall clock than this are replays and never alert.",
            "minimum": 0
          },
          "sent": {
            "type": "integer",
            "format": "int64",
            "description": "Deliveries since the bot started.",
            "minimum": 0
          },
          "thresholds": {
            "$ref": "#/components/schemas/ThresholdsState",
            "description": "What a window must clear to alert: open at least `min_duration_secs` with a current\nprofit of at least `min_profit_lovelace`."
          }
        }
      },
      "OpportunitiesQuery": {
        "type": "object",
        "properties": {
          "actionable_only": {
            "type": [
              "boolean",
              "null"
            ],
            "description": "Only windows that clear the thresholds (default true)."
          },
          "limit": {
            "type": [
              "integer",
              "null"
            ],
            "description": "Page size, 1–200 (default 50).",
            "minimum": 0
          },
          "page": {
            "type": [
              "integer",
              "null"
            ],
            "description": "The 1-based page, newest first (default 1).",
            "minimum": 0
          },
          "pair": {
            "type": [
              "string",
              "null"
            ],
            "description": "Only this pair (`lovelace/<unit>`)."
          }
        }
      },
      "OpportunityDetail": {
        "type": "object",
        "required": [
          "opportunity",
          "events"
        ],
        "properties": {
          "events": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/OpportunityEvent"
            }
          },
          "opportunity": {
            "$ref": "#/components/schemas/OpportunityView"
          }
        }
      },
      "OpportunityEvent": {
        "type": "object",
        "required": [
          "seq",
          "kind",
          "slot",
          "at"
        ],
        "properties": {
          "at": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "kind": {
            "$ref": "#/components/schemas/EventKind"
          },
          "note": {
            "type": [
              "string",
              "null"
            ]
          },
          "profit_lovelace": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int64",
            "minimum": 0
          },
          "seq": {
            "type": "integer",
            "format": "int32",
            "minimum": 0
          },
          "slot": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "trade": {
            "oneOf": [
              {
                "$ref": "#/components/schemas/TradeSnapshot"
              },
              {
                "type": "null"
              }
            ]
          }
        }
      },
      "OpportunityPage": {
        "type": "object",
        "required": [
          "windows",
          "page",
          "total"
        ],
        "properties": {
          "page": {
            "type": "integer",
            "description": "The 1-based page these windows are; past the end it is empty.",
            "minimum": 0
          },
          "total": {
            "type": "integer",
            "description": "Every window that matches the filter, across all pages.",
            "minimum": 0
          },
          "windows": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/OpportunityView"
            }
          }
        }
      },
      "OpportunityStats": {
        "type": "object",
        "required": [
          "thresholds",
          "totals",
          "days",
          "top_pairs",
          "open_now",
          "retention_days",
          "stored_windows",
          "store_bytes"
        ],
        "properties": {
          "days": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/DayStats"
            },
            "description": "Newest first, one row per day of the range, empty days included."
          },
          "oldest_opened_at": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int64",
            "minimum": 0
          },
          "open_now": {
            "type": "integer",
            "format": "int32",
            "minimum": 0
          },
          "retention_days": {
            "type": "integer",
            "format": "int32",
            "minimum": 0
          },
          "store_bytes": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "stored_windows": {
            "type": "integer",
            "minimum": 0
          },
          "thresholds": {
            "$ref": "#/components/schemas/Thresholds"
          },
          "top_pairs": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PairStats"
            }
          },
          "totals": {
            "$ref": "#/components/schemas/StatsBucket"
          }
        }
      },
      "OpportunityView": {
        "type": "object",
        "description": "A window as the API serves it: classified against the thresholds in force.",
        "required": [
          "window",
          "duration_secs",
          "actionable"
        ],
        "properties": {
          "actionable": {
            "type": "boolean"
          },
          "duration_secs": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "window": {
            "$ref": "#/components/schemas/OpportunityWindow"
          }
        }
      },
      "OpportunityWindow": {
        "type": "object",
        "required": [
          "id",
          "pair",
          "token_name",
          "status",
          "opened_slot",
          "opened_at",
          "last_seen_slot",
          "last_seen_at",
          "first_profit_lovelace",
          "peak_profit_lovelace",
          "last_profit_lovelace",
          "peak",
          "recorded_events",
          "dropped_events"
        ],
        "properties": {
          "alert_raised": {
            "type": "boolean",
            "description": "A phone alert went out and its follow-up has not. Persisted so the next start can send\nthe follow-up for a window the previous run left raised."
          },
          "closed_at": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int64",
            "minimum": 0
          },
          "closed_slot": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int64",
            "minimum": 0
          },
          "dropped_events": {
            "type": "integer",
            "format": "int32",
            "description": "Events beyond the per-window cap: counted, not stored.",
            "minimum": 0
          },
          "first_profit_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "id": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "last_profit_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "last_seen_at": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "last_seen_slot": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "opened_at": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "opened_slot": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "pair": {
            "type": "string"
          },
          "peak": {
            "$ref": "#/components/schemas/TradeSnapshot",
            "description": "The trade at the peak profit."
          },
          "peak_profit_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "recorded_events": {
            "type": "integer",
            "format": "int32",
            "minimum": 0
          },
          "status": {
            "$ref": "#/components/schemas/WindowStatus"
          },
          "token_name": {
            "type": "string"
          }
        }
      },
      "Output": {
        "type": "object",
        "required": [
          "address",
          "value"
        ],
        "properties": {
          "address": {
            "type": "string"
          },
          "datum": {},
          "datumHash": {
            "type": [
              "string",
              "null"
            ]
          },
          "value": {
            "type": "object"
          }
        }
      },
      "PaginationQuery": {
        "type": "object",
        "properties": {
          "page": {
            "type": [
              "integer",
              "null"
            ],
            "minimum": 0
          }
        }
      },
      "PairLookupQuery": {
        "type": "object",
        "required": [
          "asset_a",
          "asset_b"
        ],
        "properties": {
          "asset_a": {
            "type": "string"
          },
          "asset_b": {
            "type": "string"
          }
        }
      },
      "PairStats": {
        "allOf": [
          {
            "$ref": "#/components/schemas/StatsBucket"
          },
          {
            "type": "object",
            "required": [
              "pair",
              "token_name"
            ],
            "properties": {
              "pair": {
                "type": "string"
              },
              "token_name": {
                "type": "string"
              }
            }
          }
        ]
      },
      "PairsResponse": {
        "type": "object",
        "required": [
          "pools"
        ],
        "properties": {
          "pools": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PoolInfo"
            }
          }
        }
      },
      "PoolInfo": {
        "type": "object",
        "required": [
          "asset_a",
          "asset_b",
          "dex_name",
          "reserve_a",
          "reserve_b",
          "address",
          "price",
          "tvl",
          "calculate_buy_100",
          "calculate_sell_100",
          "transaction_id",
          "output_index",
          "buy_fee",
          "sell_fee"
        ],
        "properties": {
          "address": {
            "type": "string"
          },
          "asset_a": {
            "$ref": "#/components/schemas/AssetRef"
          },
          "asset_b": {
            "$ref": "#/components/schemas/AssetRef"
          },
          "buy_fee": {
            "type": "string"
          },
          "calculate_buy_100": {
            "type": "string"
          },
          "calculate_sell_100": {
            "type": "string"
          },
          "dex_name": {
            "type": "string"
          },
          "output_index": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "price": {
            "type": "string"
          },
          "reserve_a": {
            "type": "string"
          },
          "reserve_b": {
            "type": "string"
          },
          "sell_fee": {
            "type": "string"
          },
          "transaction_id": {
            "type": "string"
          },
          "tvl": {
            "type": "string"
          }
        }
      },
      "PoolsResponse": {
        "type": "object",
        "required": [
          "pools",
          "current_page",
          "page_size",
          "total"
        ],
        "properties": {
          "current_page": {
            "type": "integer",
            "description": "Zero-based.",
            "minimum": 0
          },
          "page_size": {
            "type": "integer",
            "minimum": 0
          },
          "pools": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/PoolInfo"
            }
          },
          "total": {
            "type": "integer",
            "description": "Every pool the dex has, across all pages.",
            "minimum": 0
          }
        }
      },
      "PruneRequest": {
        "type": "object",
        "properties": {
          "all": {
            "type": "boolean",
            "description": "Drop all closed opportunity windows and their event audit trails."
          },
          "from": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int64",
            "description": "Drop closed windows whose opening timestamp is >= `from` (UTC unix seconds).",
            "minimum": 0
          },
          "older_than_days": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int32",
            "description": "Drop closed windows older than this many days from now.",
            "minimum": 0
          },
          "to": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int64",
            "description": "Drop closed windows whose end timestamp is <= `to` (UTC unix seconds).",
            "minimum": 0
          }
        }
      },
      "PruneResponse": {
        "type": "object",
        "required": [
          "pruned",
          "store_bytes"
        ],
        "properties": {
          "pruned": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "store_bytes": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          }
        }
      },
      "StatsBucket": {
        "type": "object",
        "required": [
          "opportunities",
          "actionable",
          "potential_profit_lovelace",
          "best_profit_lovelace",
          "avg_duration_secs",
          "longest_duration_secs"
        ],
        "properties": {
          "actionable": {
            "type": "integer",
            "format": "int32",
            "minimum": 0
          },
          "avg_duration_secs": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "best_profit_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "longest_duration_secs": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "opportunities": {
            "type": "integer",
            "format": "int32",
            "minimum": 0
          },
          "potential_profit_lovelace": {
            "type": "integer",
            "format": "int64",
            "description": "Sum of the actionable windows' peak profits: what taking every one would have earned.",
            "minimum": 0
          }
        }
      },
      "StatsQuery": {
        "type": "object",
        "properties": {
          "days": {
            "type": [
              "integer",
              "null"
            ],
            "format": "int32",
            "description": "UTC days back from the newest chain time, 1–90 (default 14).",
            "minimum": 0
          },
          "pair": {
            "type": [
              "string",
              "null"
            ],
            "description": "Only this pair (`lovelace/<unit>`), as the top pairs name it."
          }
        }
      },
      "Thresholds": {
        "type": "object",
        "description": "What makes a window worth a human's attention. Applied when reading, so changing it\nre-classifies everything already recorded.",
        "required": [
          "min_duration_secs",
          "min_profit_lovelace"
        ],
        "properties": {
          "min_duration_secs": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "min_profit_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          }
        }
      },
      "ThresholdsState": {
        "type": "object",
        "required": [
          "effective",
          "env_default",
          "overridden"
        ],
        "properties": {
          "effective": {
            "$ref": "#/components/schemas/Thresholds"
          },
          "env_default": {
            "$ref": "#/components/schemas/Thresholds"
          },
          "overridden": {
            "type": "boolean",
            "description": "True while a value saved from the UI replaces the env default."
          }
        }
      },
      "TradeSnapshot": {
        "type": "object",
        "description": "The trade the bot computed at one observation: enough to find both pools on an explorer and\ncheck the numbers. Its own type rather than [`ArbitrageDisplayItem`], so a change to the live\npage's shape cannot make recorded history undecodable.",
        "required": [
          "buy_dex",
          "sell_dex",
          "buy_amount_lovelace",
          "token_amount",
          "sell_receive_lovelace",
          "buy_pool_utxo",
          "sell_pool_utxo",
          "buy_pool_tvl_lovelace",
          "sell_pool_tvl_lovelace"
        ],
        "properties": {
          "buy_amount_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "buy_dex": {
            "type": "string"
          },
          "buy_pool_tvl_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "buy_pool_utxo": {
            "type": "string"
          },
          "sell_dex": {
            "type": "string"
          },
          "sell_pool_tvl_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "sell_pool_utxo": {
            "type": "string"
          },
          "sell_receive_lovelace": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "token_amount": {
            "type": "string"
          }
        }
      },
      "Transaction": {
        "type": "object",
        "required": [
          "id",
          "inputs",
          "outputs"
        ],
        "properties": {
          "datums": {},
          "id": {
            "type": "string"
          },
          "inputs": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/Input"
            }
          },
          "outputs": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/Output"
            }
          },
          "scripts": {},
          "signatories": {
            "type": [
              "array",
              "null"
            ],
            "items": {}
          }
        }
      },
      "TransactionHistoryResponse": {
        "type": "object",
        "required": [
          "transaction"
        ],
        "properties": {
          "transaction": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ArbitrageHistoryItem"
            }
          }
        }
      },
      "UtxoLookupQuery": {
        "type": "object",
        "required": [
          "transaction_id",
          "index"
        ],
        "properties": {
          "index": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "transaction_id": {
            "type": "string"
          }
        }
      },
      "UtxoQuery": {
        "type": "object",
        "required": [
          "transaction_id",
          "index"
        ],
        "properties": {
          "index": {
            "type": "integer",
            "format": "int64",
            "minimum": 0
          },
          "transaction_id": {
            "type": "string"
          }
        }
      },
      "UtxoResponse": {
        "type": "object",
        "required": [
          "utxo"
        ],
        "properties": {
          "utxo": {
            "$ref": "#/components/schemas/DisplayUtxo"
          }
        }
      },
      "WindowStatus": {
        "type": "string",
        "enum": [
          "open",
          "closed",
          "interrupted"
        ]
      }
    }
  },
  "tags": [
    {
      "name": "Addresses",
      "description": "Address management endpoints"
    },
    {
      "name": "Arbitrages",
      "description": "Arbitrage management endpoints"
    },
    {
      "name": "Opportunities",
      "description": "Recorded arbitrage opportunity windows, their statistics and actionability thresholds"
    },
    {
      "name": "Pairs",
      "description": "Pair management endpoints"
    },
    {
      "name": "Pools",
      "description": "Pool management endpoints"
    },
    {
      "name": "Regulus",
      "description": "Regulus management endpoints"
    },
    {
      "name": "UTXOs",
      "description": "UTXO management endpoints"
    },
    {
      "name": "Wallet",
      "description": "Wallet management endpoints"
    }
  ]
}
